import * as React from 'react';
import type { IListPageLayoutControlsProps } from './list-page-layout.types';
import { cn } from '@utils';

export const ListPageLayoutControls = React.forwardRef<HTMLDivElement, IListPageLayoutControlsProps>(
	({ className, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex flex-wrap items-center gap-3 w-full', className)}
			data-testid="list-page-layout-controls"
			{...props}
		>
			{children}
		</div>
	)
);
ListPageLayoutControls.displayName = 'ListPageLayoutControls';
